import actions from '@/core/store/anuencia/actions.js'
import assinatura from '@/core/store/anuencia/assinatura'
import documentos from '@/core/store/anuencia/documentos'

export default {
	actions,
	modules: {
		assinatura,
		documentos,
	},
}
